import React, { Fragment } from "react";
import { Link } from "react-router";

import { Table, Alert } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import { EanNumber, Money, OurDate } from "shared/components";

export class OrderGroupSummaryInTable extends React.Component {
  constructor() {
    super();

    this.state = {
      expanded: false,
    };
  }

  toggle() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  render() {
    const SHORT_ORDER_NOTE_LENGTH = 60;
    const { orderGroup } = this.props;
    const { orders } = orderGroup;
    const firstOrder = orders[0];
    const shortOrderNote = firstOrder.note
      ? firstOrder.note.length <= SHORT_ORDER_NOTE_LENGTH
        ? firstOrder.note
        : `${firstOrder.note.substr(0, SHORT_ORDER_NOTE_LENGTH)}…`
      : "-";

    return (
      <tbody>
        {orders.map((order, idx) => (
          <tr
            key={idx}
            onClick={this.toggle.bind(this)}
            className={`order-group-summary order-group-summary-${
              orderGroup.id
            } ${this.state.expanded ? "expanded" : "collapsed"}`}
          >
            <td>
              <p>{order.referenceCode}</p>
            </td>
            <td>
              <OurDate value={orderGroup.createdAt} />
            </td>
            <td>
              <Money cents={order.netSumCents} />
            </td>
            <td>
              {orderGroup.merchantRegion ? (
                <FormattedMessage
                  id={`edeka.region.${orderGroup.merchantRegion}`}
                />
              ) : (
                "Keine Angabe"
              )}
            </td>
            <td>
              <pre className="market-address">
                {order.billingAddress || "Keine Angabe"}
              </pre>
            </td>
            <td>
              <pre className="market-address">
                {order.shippingAddress || "Keine Angabe"}
              </pre>
            </td>
            <td>{shortOrderNote}</td>
          </tr>
        ))}
        <tr
          className={`order-summary-details ${
            this.state.expanded ? "expanded" : "collapsed"
          }`}
        >
          <td colSpan="7">
            <div className="order-summary-details-intro">
              Diese Bestellung(en) beinhalten folgende Bestelleinheiten:
            </div>
            <Table condensed bordered className="order-summary-details-list">
              <tbody>
                <Choose>
                  <When
                    condition={
                      !firstOrder.orderItems ||
                      firstOrder.orderItems.length === 0
                    }
                  >
                    <tr key={`no-orderItems-${firstOrder.id}`}>
                      <td colSpan={4}>Keine Bestelleinheiten vorhanden</td>
                    </tr>
                  </When>
                  <When
                    condition={
                      firstOrder.orderItems && firstOrder.orderItems.length > 0
                    }
                  >
                    {firstOrder.orderItems.map(orderItem => {
                      const orderAndCount = orderItem.orderUnit.orderUnitType
                        ? `${orderItem.orderUnit.orderUnitType}, ${orderItem.orderUnit.sumProductCount}`
                        : orderItem.orderUnit.sumProductCount;

                      return (
                        <tr key={`oi-${orderItem.id}`}>
                          <td>{orderItem.amount}×</td>
                          <td>
                            {orderItem.orderUnit.name} ({orderAndCount}{" "}
                            <span title="Verkaufseinheiten">VKE</span>)
                          </td>
                          <td className="price">
                            <Money
                              cents={orderItem.amount * orderItem.netPriceCents}
                            />
                          </td>
                          <td>
                            EAN <EanNumber ean={orderItem.orderUnit.ean} />
                          </td>
                        </tr>
                      );
                    })}
                  </When>
                </Choose>
                {firstOrder.discountsInKind &&
                firstOrder.discountsInKind.length > 0
                  ? firstOrder.discountsInKind.map(discountInKind => {
                      const orderAndCount = discountInKind.orderUnit
                        .orderUnitType
                        ? `${discountInKind.orderUnit.orderUnitType}, ${discountInKind.orderUnit.sumProductCount}`
                        : discountInKind.orderUnit.sumProductCount;
                      return (
                        <tr key={`oi-${discountInKind.id}`}>
                          <td>{discountInKind.count}×</td>
                          <td>
                            {discountInKind.orderUnit.name} ({orderAndCount}{" "}
                            <span title="Verkaufseinheiten">VKE</span>)
                          </td>
                          <td className="price">Naturalrabatt</td>
                          <td>
                            EAN <EanNumber ean={discountInKind.orderUnit.ean} />
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </Table>
            {firstOrder.note && (
              <div>
                <div className="order-summary-details-intro">
                  Die Kaufleute haben zu dieser Bestellung folgende Nachricht
                  hinterlassen:
                </div>
                <div className="order-summary-details-note">
                  {firstOrder.note}
                </div>
              </div>
            )}
          </td>
        </tr>
      </tbody>
    );
  }
}

const OrderGroupsOverviewTable = props => {
  return (
    <Table condensed bordered hover className="order-groups-table">
      <thead>
        <tr>
          <th>
            <FormattedMessage id="fs.orderReferenceShort" />
          </th>
          <th>
            <FormattedMessage id="fs.date" />
          </th>
          <th>
            <FormattedMessage id="fs.netSum" />
          </th>
          <th>
            <FormattedMessage id="fs.region" />
          </th>
          <th>
            <FormattedMessage id="fs.billingInfo" />
          </th>
          <th>
            <FormattedMessage id="fs.market" />
          </th>
          <th>
            <FormattedMessage id="fs.orderNote" />
          </th>
        </tr>
      </thead>
      {props.orderGroups.map(orderGroup => {
        return (
          <OrderGroupSummaryInTable
            orderGroup={orderGroup}
            key={orderGroup.id}
          />
        );
      })}
    </Table>
  );
};

const OrderGroupsOverview = props => {
  return (
    <div>
      <p className="content-header">Bestellübersicht</p>

      {props.orderGroups.length === 0 ? (
        <Alert>Du hast noch keine Bestellungen erhalten.</Alert>
      ) : (
        <>
          <OrderGroupsOverviewTable orderGroups={props.orderGroups} />
          {props.params.scope !== "all" && (
            <Link to={`${props.location.pathname}/all`}>Alle anzeigen</Link>
          )}
        </>
      )}
    </div>
  );
};

export default OrderGroupsOverview;
